module.exports = __webpack_public_path__ + "static/media/sandik_1.ddc5d89e.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/albums/sandik_1.jpeg
// module id = 308
// module chunks = 0